<template>
    <div class="container">
  <div class="px-4 py-5 text-center text-light h-50">
    <h2 class="display-4 fw-bold">Patient Management System</h2>
    <div class="col-lg-6 mx-auto">
      <p class="lead mb-4">This site has been put together using <code>Laravel 10</code>  and some frontend helpers provided by <code>TailwindCSS</code> and <code>AlpineJS</code>.
        This application demo's a Patient Management System. It has CRUD functionality. It enables an organisation to create, store and search for patient data.
      </p>
      <p>Laravel 10 | NodeJS - NPM | TailwindCSS | AlpineJS | FilamentPHP</p>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4">PMS</button>
        <a href="/files/pms.apk" download="pms.apk"><img src="../assets/img/logos/play.png" alt="download android app" width="48" height="48"></a>
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="container px-5">
        <a href="https://pms.saqibofficial.com" target="_blank"><img src="../assets/img/pmsthumbnail.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="cv site" width="700" height="900" loading="lazy"></a>      </div>
    </div>
  </div>
</div>
</template>